import React from 'react';

/**
 * German License Plate Component
 * Displays license plate in authentic German style with EU band
 */
const LicensePlate = ({ plate, size = 'md' }) => {
  if (!plate) return null;

  // Parse German license plate format: HH-ZO 205
  const parts = plate.split('-');
  const city = parts[0] || '';
  const rest = parts[1] || '';

  const sizes = {
    sm: { container: 'h-6 px-2 text-xs', eu: 'w-4 text-[8px]', city: 'text-xs', chars: 'text-xs' },
    md: { container: 'h-10 px-3 text-base', eu: 'w-6 text-xs', city: 'text-base', chars: 'text-base' },
    lg: { container: 'h-14 px-4 text-xl', eu: 'w-8 text-sm', city: 'text-xl', chars: 'text-xl' }
  };

  const s = sizes[size];

  return (
    <div className={`inline-flex items-center ${s.container} bg-white border-2 border-black rounded-md shadow-sm font-mono font-bold overflow-hidden`}>
      {/* EU Band */}
      <div className={`${s.eu} h-full bg-[#003399] flex flex-col items-center justify-center text-white flex-shrink-0 -ml-3 mr-2`}>
        <div className={`${s.eu === 'w-4' ? 'text-[6px]' : 'text-[8px]'} leading-none`}>★ ★</div>
        <div className={`${s.eu === 'w-4' ? 'text-[6px]' : s.eu === 'w-6' ? 'text-[10px]' : 'text-xs'} font-bold leading-none mt-0.5`}>D</div>
      </div>

      {/* City Code */}
      <div className={`${s.city} text-black font-bold tracking-tight`}>
        {city}
      </div>

      {/* Separator */}
      {rest && (
        <>
          <div className="w-px h-4 bg-black mx-1.5"></div>
          {/* Characters & Numbers */}
          <div className={`${s.chars} text-black font-bold tracking-wider`}>
            {rest}
          </div>
        </>
      )}
    </div>
  );
};

export default LicensePlate;
